import { AppModule } from './app/modules/app.module';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


declare global {
  interface Window {
    OneTrust: any;
  }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch((err) => console.error(err));
